<template>
  <div class="projectManagement-index">
    <el-button type="text" @click="dialogTableVisible = true">打开嵌套表格的 Dialog</el-button>

    <el-dialog title="收货地址" :visible.sync="dialogTableVisible" width="90%">
      <project-pop-up-view @Cancel="cancelElDialog" />
    </el-dialog>
  </div>
</template>

<script>
import projectPopUpView from './projectPopUpView.vue'

export default {
  name: 'ProjectManagementIndex',
  components: {
    projectPopUpView
  },
  data() {
    return {
      dialogTableVisible: false
    }
  },
  mounted() {
    const self = this
    window.projectManagementIndex = self
  },
  methods: {
    /**
     * 关闭弹窗
     */
    cancelElDialog() {
      this.dialogTableVisible = false
    }
  }
}
</script>
<style scoped lang="scss">

</style>
